import { create } from 'zustand';

type TerminalModeState = {
  mode: string;
  setMode: (mode: string) => void;
};

export const useTerminalModeStore = create<TerminalModeState>((set) => ({
  mode: 'terminal',
  setMode: (mode) => set({ mode }),
}));